import styles from './ValidateButton.module.scss';
import Loader from '../Loader';

type ValidateButtonProps = {
    title: string;
    inverted?: boolean;
    disabled?: boolean;
    onClick?: () => void;
    onLoading?: boolean;
    isModal?: boolean;
    blueGradient?: boolean;
    isSignatureModal?: boolean;
    isInvertedSignatureModal?: boolean
}

const ValidateButton: React.FC<ValidateButtonProps> = ({title, inverted, disabled, onClick, onLoading, isModal, blueGradient, isSignatureModal, isInvertedSignatureModal}) => {
    const buttonClasses = [
        styles.button,
        inverted ? styles.solidColorBackground : styles.gradientBackground,
        disabled || onLoading ? styles.transparentButton : styles.opacityButton,
        blueGradient && styles.blueGradient,
        isSignatureModal && styles.gradientBackground,
        isInvertedSignatureModal && styles.invertedSignatureModal
    ].filter(Boolean).join(' ');

    const modalButton = isModal || isSignatureModal || isInvertedSignatureModal;

    return (
        <div
            className={buttonClasses}
            onClick={disabled ? undefined : onClick}
            style={{
                margin: modalButton ? '10px 10px' : '50px auto 10px auto',
                minHeight: modalButton ? '40px' : '50px',
            }}
        >
            {!onLoading && <p className={styles.buttonLabel} style={{fontSize: modalButton ? '14px' : '16px' }}>{title}</p>}
            {onLoading && <Loader type="BUBBLES" />}
        </div>
    );
}

export default ValidateButton;
